// 個別相談案件登録のラベル
export const LABELS = {
  TITLE: "基本情報",
  CORPORATE_NUMBER: "法人番号",
  INDIVIDUAL_NO: "個別相談No",
  BRANCH_NO: "個別相談枝番",
  SEARCH: "法人番号検索",
  COMPANY_NAME: "事業者名",
  INDIVIDUAL_CONSULTATION_BRANCH_NO: "枝番",
  MERCHANT_NAME: "加盟店名",
  CONTRACT_SERVICE_NAME: "サービス名",
  CONTRACT_STYLE: "契約形態",
  CONTRACT_ROUTE: "契約ルート",
  CONSIDERATION_POLICY: "検討方針",
  CONSIDERATION_STATUS: "検討状況",
  LAST_UPDATED_DATE: "最終更新日",

  TAB_TITLE_INDIVIDUAL_CONSULTATION_PROJECT_LIST: "相談案件一覧",
  INDIVIDUAL_CONSULTATION_PROJECT_TITLE: "相談内容追加",
  TAB_TITLE: "相談案件一覧",
  TAB_CONTRACT_STYLE_DIRECT: "直接",
  TAB_CONTRACT_STYLE_INCLUSION: "包括",
  TAB_CONTRACT_STYLE_EXAMINATION: "検討中",
  TAB_CONTRACT_STYLE_DIRECT_NO: "1",
  TAB_CONTRACT_STYLE_INCLUSION_NO: "2",
  TAB_CONTRACT_STYLE_EXAMINATION_NO: "3",
} as const;
